export const removeKey = () => {
  localStorage.clear();
  sessionStorage.clear();
}